// src/pages/InsightsPage.js
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./InsightsPage.css";

const articles = [
  {
    slug: "ai-crypto-signals-app-android",
    title: "AI Crypto Signals App For Smart Traders On Android",
    category: "Crypto & Stocks",
    readTime: "15–20 min read",
    highlight:
      "A deep dive into how an AI crypto signals app like Trend Genie works on Android, how to read AI signals, and how to combine them with solid risk management.",
    path: "/insights/ai-crypto-signals-app-android",
  },
  {
    slug: "risk-management-small-trading-accounts",
    title: "Risk Management For Small Trading Accounts Using AI Signals",
    category: "Risk Management",
    readTime: "15–20 min read",
    highlight:
      "Practical risk management strategies for small accounts, including position sizing, drawdown control, and how to safely use AI trading signals.",
    path: "/insights/risk-management-small-trading-accounts",
  },
  {
    slug: "crypto-signals-for-beginners",
    title: "Crypto Signals For Beginners: How To Read And Use Them Safely",
    category: "Beginner Guides",
    readTime: "15–20 min read",
    highlight:
      "A complete beginner-friendly guide to understanding crypto signals, common terms, and how to avoid the most frequent mistakes new traders make.",
    path: "/insights/crypto-signals-for-beginners",
  },
  {
    slug: "ai-trading-signals-android",
    title: "AI Trading Signals On Android: Turn Your Phone Into A Trading Assistant",
    category: "Mobile Trading",
    readTime: "15–20 min read",
    highlight:
      "How AI trading signals on Android fit into a busy schedule, and how to build a mobile-first workflow with Trend Genie.",
    path: "/insights/ai-trading-signals-android",
  },
];

function InsightsPage() {
  const baseUrl = "https://trendgenie.io";

  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: articles.map((article, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `${baseUrl}${article.path}`,
      name: article.title,
    })),
  };

  return (
    <div className="page insights-page">
      <Helmet>
        <title>Genie Insights: AI Trading Articles and Guides | Trend Genie</title>
        <meta
          name="description"
          content="Genie Insights is the learning hub for Trend Genie users. Read in-depth articles on AI crypto signals, risk management, beginner crypto signal guides, and mobile trading workflows."
        />
        <script type="application/ld+json">
          {JSON.stringify(itemListSchema)}
        </script>
      </Helmet>

      <section className="insights-hero">
        <h1>Genie Insights</h1>
        <p className="insights-subtitle">
          Long-form articles and practical guides on AI crypto signals, risk management, beginner education, and
          mobile-first trading with Trend Genie.
        </p>
      </section>

      <section className="insights-list">
        {articles.map((article) => (
          <article key={article.slug} className="insights-card">
            <div className="insights-card-meta">
              <span className="insights-category">{article.category}</span>
              <span className="insights-dot">•</span>
              <span className="insights-readtime">{article.readTime}</span>
            </div>

            <h2 className="insights-title">{article.title}</h2>
            <p className="insights-highlight">{article.highlight}</p>

            <Link to={article.path} className="insights-btn">
              Read article
            </Link>
          </article>
        ))}
      </section>
    </div>
  );
}

export default InsightsPage;
